import { COLORS } from '@btime/constants'
import { length } from 'ramda'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useUploadRequest } from '../../utils/hooks/uploadV2'
import Gallery from '../presentation/gallery/Gallery'
import IconButton from '../actions/IconButton'
import Loading from '../helpers/Loading'

const GalleryInput = ({
  value,
  onChange,
  buttonLabel,
  limit,
  accept,
  useRotation,
  externalLoading = false,
  multiple = true,
  ...props
}) => {
  const { t } = useTranslation()

  const [upload, state] = useUploadRequest(values => {
    onChange([...(value || []), ...values])
  })

  const { loading: internalLoading } = state
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: upload,
    accept: accept || 'image/*,video/*,application/*'
  })

  const canAddMore = !limit || length(value || []) < limit

  const onRemove = (item, indexToRemove) => onChange((value || []).filter((_, index) => index !== indexToRemove))

  return (
    <Gallery {...props} onChange={onChange} items={value || []} onRemove={onRemove} useRotation={useRotation}>
      {(internalLoading || externalLoading) && <Loading />}
      {canAddMore && (
        <div {...getRootProps()}>
          <input {...getInputProps()} multiple={multiple} />
          <IconButton
            useDiv
            label={buttonLabel || t('addPhoto')}
            transparent={!isDragActive}
            color={COLORS.dark3}
            borderColor={COLORS.light3}
            small
            icon="BsCardImage"
            iconSize="1.1rem"
            iconTop
          />
        </div>
      )}
    </Gallery>
  )
}

export default GalleryInput
